export const styles = {
  Sec1MainGrid: {
    width: { lg: "586px", md: "520px", sm: "510px", xs: "350px" },
    height: { lg: "294px", sm: "300px", xs: "350px" },
    borderRadius: {sm:"50px"},
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    pl: 3,
    pr: 3,
  },
  boxTypo: {
    fontSize: { lg: "40px", sm: "33px", xs: "30px" },
    marginTop: "45px",
    justifyContent: "center",
    fontWeight: 700,
    lineHeight: "35px",
  },
  boxContent: {
    fontSize: { lg: "26px", sm: "24px", xs: "18px" },
    fontWeight: 600,
    marginTop: "30px",
  },
  textCapitalize: { textTransform: "capitalize" },
  // Section 2 style
  Sec2Box: { px: { xs: 2, md: 5 } },
  Sec2BoxTitle: {pt: "60px", pb: "0px"},
  Sec2Typo: {
    width: { lg: "900px" },
    height: "auto",
    lineHeight: "44px",
    fontSize: {xs:"28px", md:"36px"},
    fontWeight: 700,
    textAlign: "start",
  },
  subGridImgBox: { width: "150px", height: "150px", marginTop: "0px" },
  subgridTypoHeading: {
    fontSize: {xs:"28px", sm:"28px"},
    fontWeight: 700,
    textAlign: "center",
    marginTop: "20px",
    color:"primary"
  },
  subgridTypoDescription: {
    fontSize: {xs: "18px", sm:"20px"},
    fontWeight: 600,
    textAlign: "center",
    marginTop: "25px",
    height: "auto",
  },
  subGridSx: {
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
  },
  buttonGridSx: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
  containerGridSx: {
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    mt: 8,
    mx: {xs:2, sm:8},
  },
  descriptionBoxSx: {
    px: { md: 3 },
  },
  descriptionBoxSx2: {
    px: { md: 4 },
  },
  faqBoxSx: {
    mt: 10,
  },
};
